import { FaChartLine } from "react-icons/fa";
import { IoIosTrendingDown } from "react-icons/io";
import { Card } from "../common/Card";
import SubscriptionReportData from "../../common/reportDashBShimmer/SubscriptionReportData";
import { WalletSectionError } from "./WalletSectionError";

export function WalletHighValueSection({ state, activityData }) {
  return (
    <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
      <span className="mb-4 text-[#1A1A1A] text-lg">
        High-Value Wallet Activity
      </span>
      <div className="space-y-4">
        {state.loading ? (
          <SubscriptionReportData />
        ) : state.error ? (
          <WalletSectionError message={state.message} onRetry={state.onRetry} />
        ) : activityData.length > 0 ? (
          activityData.map((transaction, index) => {
            const isCredit = transaction.amount > 0;
            return (
              <div
                key={index}
                className="flex items-center justify-between p-4 bg-[#F8F9FC] rounded-lg"
              >
                <div className="flex items-center gap-4 flex-1">
                  <div
                    className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                      isCredit ? "bg-green-100" : "bg-red-100"
                    }`}
                  >
                    {isCredit ? (
                      <IoIosTrendingDown className="w-5 h-5 text-green-600" />
                    ) : (
                      <FaChartLine className="w-5 h-5 text-red-600" />
                    )}
                  </div>
                  <div>
                    <div className="text-[#1A1A1A]">{transaction.entity}</div>
                    <div className="text-[#6B7280]">
                      {transaction.type} • {transaction.timestamp}
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className={isCredit ? "text-green-600" : "text-red-600"}>
                    {isCredit ? "+" : "-"}
                    {transaction.currency}{" "}
                    {Math.abs(transaction.amount).toLocaleString()}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="flex justify-center items-center h-40 text-gray-400">
            No high-value wallet activity
          </div>
        )}
      </div>
    </Card>
  );
}
